exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@-webkit-keyframes EditMessageDialog_fadeIn__2LR6N {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes EditMessageDialog_fadeIn__2LR6N {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@-webkit-keyframes EditMessageDialog_fadeOut__3vr3w {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes EditMessageDialog_fadeOut__3vr3w {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n.EditMessageDialog_content__22oHy {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: column;\n          flex-direction: column; }\n  .EditMessageDialog_content__22oHy > div:first-child {\n    display: -webkit-flex;\n    display: flex;\n    -webkit-align-items: baseline;\n            align-items: baseline;\n    margin-bottom: 16px; }\n    .EditMessageDialog_content__22oHy > div:first-child > * {\n      margin-right: 8px; }\n", ""]);

// exports
exports.locals = {
	"color": "#ff3b00",
	"colorSecondary": "#4caf50",
	"colorContrastText": "#ffffff",
	"colorLight": "#ff7349",
	"colorDark": "#ce3000",
	"colorSecondaryLight": "#81c784",
	"colorSecondaryDark": "#388e3b",
	"hostColor": "#eb8315",
	"hostColorSecondary": "#f44336",
	"hostColorContrastText": "#ffffff",
	"hostColorLight": "#ffa74a",
	"hostColorDark": "#cf6a00",
	"content": "EditMessageDialog_content__22oHy",
	"fadeIn": "EditMessageDialog_fadeIn__2LR6N",
	"fadeOut": "EditMessageDialog_fadeOut__3vr3w"
};